import { RECEIVE_GENERAL_SUMMARY, REQUEST_GENERAL_SUMMARY } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_GENERAL_SUMMARY:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_GENERAL_SUMMARY: {
            return { ...state, ...data, isFetching: false }
        }

        default:
            return state
    }
}
